module.exports = __webpack_public_path__ + "img/aps-1.dee77c23.png";